module.exports = __webpack_public_path__ + "f5305e2c11736df1be5c4968ee1fdda5.MP3";